import { render } from "./SystemBarMobile.vue?vue&type=template&id=5a0f8c34"
import script from "./SystemBarMobile.vue?vue&type=script&lang=js"
export * from "./SystemBarMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__